import { render, staticRenderFns } from "./ReportArrears.vue?vue&type=template&id=03199ca4&scoped=true&"
import script from "./ReportArrears.vue?vue&type=script&lang=js&"
export * from "./ReportArrears.vue?vue&type=script&lang=js&"
import style0 from "./ReportArrears.vue?vue&type=style&index=0&id=03199ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03199ca4",
  null
  
)

export default component.exports